export default "__VITE_ASSET__By6mlzb0__"